// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"01506283","977":"a555b9fa"}[chunkId] + ".chunk.js";
};